
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Слой 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"20 20 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"22.32","y":"22.9","width":"55.36","height":"54.2","rx":"6.17","fill":"#fff"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M46.87 63.48h-.07a2.47 2.47 0 01-2-1.07L33.72 46.58a2.5 2.5 0 114.09-2.87L47 56.8l15.27-19.33a2.5 2.5 0 113.92 3.1l-17.36 22a2.48 2.48 0 01-1.96.91z"}})])
          )
        }
      }
    